import {IGameFilterDefinition} from "../filters-definitions/game-filter-definition.interface";
import {VendorFilterDefinition} from "../filters-definitions/vendor/vendor.filter-definition";
import {FilterCategoryDefinitionBase} from "./filter-category-definition-base";
import {CategoryDefinitionId} from "./filter-category-definition.interface";
import {Check} from "@sparkware/app-utils";

export class GameVendorFiltersCategoryDefinition extends FilterCategoryDefinitionBase {

    get id(): CategoryDefinitionId {
        return 'vendors';
    }

    get title(): string{
        return this.services.translation.translate('GAME_STUDIO');
    }

    get hasItsOwnFiltersOrder(): boolean {
        return !Check.isEmpty(this.services.configuration.data.generalSettings.filters?.advancedFilters?.preferredVendorFilters);
    }

    public getAllPreferredVendorsFilters(): VendorFilterDefinition[] {
        return [
            new VendorFilterDefinition("vendor_888","888", [1], this.services.translation.translate("BRAND_EXCLUSIVE_FILTER", {brandName: this.services.configuration.data.generalSettings.filters?.exclusiveFilterBrandName ?? "888"})),
            new VendorFilterDefinition("vendor_ags","AGS", [54]),
            new VendorFilterDefinition("vendor_amatic","Amatic", [42]),
            new VendorFilterDefinition("vendor_authentic","Authentic", [81]),
            new VendorFilterDefinition("vendor_blueprint","Blueprint", [21]),
            new VendorFilterDefinition("vendor_darwin","Darwin", [114]),
            new VendorFilterDefinition("vendor_egt","EGT", [83]),
            new VendorFilterDefinition("vendor_elk","Elk", [33]),
            new VendorFilterDefinition("vendor_evolution","Evolution", [14]),
            new VendorFilterDefinition("vendor_eyecon","Eyecon", [56]),
            new VendorFilterDefinition("vendor_gamesglobal","Games Global", [40]),
            new VendorFilterDefinition("vendor_gamingrealms","Gaming Realms", [71]),
            new VendorFilterDefinition("vendor_gamomat","Gamomat", [82]),
            new VendorFilterDefinition("vendor_greentube","Greentube", [57]),
            new VendorFilterDefinition("vendor_h5","H5", [50]),
            new VendorFilterDefinition("vendor_habanero","Habanero", [64]),
            new VendorFilterDefinition("vendor_igt","IGT", [32]),
            new VendorFilterDefinition("vendor_inspired","Inspired", [61]),
            new VendorFilterDefinition("vendor_isoftbet","iSoftBet", [58]),
            new VendorFilterDefinition("vendor_lightningbox","Lightning Box", [46]),
            new VendorFilterDefinition("vendor_lnw","LNW", [28, 5]),
            new VendorFilterDefinition("vendor_merkur","Merkur", [35]),
            new VendorFilterDefinition("vendor_mga","MGA", [65]),
            new VendorFilterDefinition("vendor_netent","Netent", [13, 27], `NetEnt`),
            new VendorFilterDefinition("vendor_nextgen_bigtime","NextGen_Big Time", [36], `Big Time`),
            new VendorFilterDefinition("vendor_nextgen_chanceinteractive","NextGen_Chance Interactive", [52], `Reel Play`),
            new VendorFilterDefinition("vendor_nolimitcity","No Limit City", [103]),
            new VendorFilterDefinition("vendor_playngo","Play N Go", [53], `Play'n GO`),
            new VendorFilterDefinition("vendor_playtech","PlayTech", [30], `Playtech`),
            new VendorFilterDefinition("vendor_pragmatic","Pragmatic", [48]),
            new VendorFilterDefinition("vendor_quickspin","Quickspin", [39]),
            new VendorFilterDefinition("vendor_redrake","Red Rake", [87]),
            new VendorFilterDefinition("vendor_redtiger","Red Tiger", [47]),
            new VendorFilterDefinition("vendor_rubyplay","Ruby Play", [51]),
            new VendorFilterDefinition("vendor_sigma","Sigma", [37]),
            new VendorFilterDefinition("vendor_skywind","Skywind", [63]),
            new VendorFilterDefinition("vendor_spribe","Spribe", [108]),
            new VendorFilterDefinition("vendor_thunderkick","Thunderkick", [34]),
            new VendorFilterDefinition("vendor_wizard","Wizard", [38]),
            new VendorFilterDefinition("vendor_wmg","WMG", [74]),
            new VendorFilterDefinition("vendor_yggdrasil","Yggdrasil", [41]),
            new VendorFilterDefinition("vendor_everi","Everi", [99]),
        ];
    }

    private _getPreferredVendorFiltersForCurrentSkin(): VendorFilterDefinition[] {
        const preferredVendorsFiltersIds = this.services.configuration.data.generalSettings.filters?.advancedFilters?.preferredVendorFilters ?? [];
        if(preferredVendorsFiltersIds.length === 0) {
            return [...this.getAllPreferredVendorsFilters()];
        }

        const allPreferredVendorsFiltersMap = this.getAllPreferredVendorsFilters().toDictionary(f => f.id);
        const result: VendorFilterDefinition[] = [];
        for(let filterId of preferredVendorsFiltersIds) {
            const filter = allPreferredVendorsFiltersMap[filterId];
            if(filter) {
                result.push(filter)
            } else {
                this.services.logger.error(`There is no definition for game vendor filter with id ${filterId}`)
            }
        }

        return result;
    }

    protected _loadAvailableFilters(): IGameFilterDefinition[] {
        const filters = this._getPreferredVendorFiltersForCurrentSkin();
        let preferredVendorsIds: number[] = filters.selectMany(f => f.vendorIds);
        const otherVendorsIds: number[] = [];

        const allVendorsIds = Object.keys(this.services.sdk.getGamesVendors()).map(id => parseInt(id));
        for(let vendorId of allVendorsIds) {
            if(!preferredVendorsIds.includes(vendorId)) {
                otherVendorsIds.push(vendorId);
            }
        }

        if(otherVendorsIds.length > 0) {
            filters.push(new VendorFilterDefinition('vendor_others', 'OTHERS', otherVendorsIds, this.services.translation.translate('OTHERS')));
        }


        return filters;
    }
}
